import { cn } from '@/lib/utils'
import { Icon } from './icon'

interface ResultCardProps {
  /** Rótulo acima do número-herói ("Cobre no mínimo", "Você vai faturar ~"). */
  heroLabel: string
  /** Número-herói já formatado (brl/pct). */
  heroValue: string
  /** Sufixo do número ("/hora", "/ano"). */
  heroSuffix?: string
  /** Cor do topo: petróleo (padrão) ou vermelho (prejuízo). */
  tone?: 'brand' | 'neg'
  /** Mostra o logo CalculaMEI no topo (para exportação). */
  withLogo?: boolean
  /** Detalhamento (DetailRow/RowStrong). */
  children?: React.ReactNode
  className?: string
}

/**
 * Cartão de resultado — peça central. NUNCA é documento: topo colorido com
 * número-herói em mono e corpo branco com detalhamento.
 */
export function ResultCard({
  heroLabel,
  heroValue,
  heroSuffix,
  tone = 'brand',
  withLogo,
  children,
  className,
}: ResultCardProps) {
  const isNeg = tone === 'neg'
  return (
    <div className={cn('overflow-hidden rounded-xl border border-line bg-surface shadow-lift', className)}>
      <div
        className={cn(
          'px-[22px] py-6',
          isNeg
            ? 'bg-gradient-to-br from-neg to-[#8a2626]'
            : 'bg-gradient-to-br from-brand to-[#0c4f55]'
        )}
      >
        {withLogo && (
          <div className="mb-4 flex items-center gap-1.5">
            <div className="flex h-[22px] w-[22px] items-center justify-center bg-white/20">
              <Icon name="calculator" size={13} className="text-white" />
            </div>
            <span className="text-[13px] font-semibold text-white">
              Calcula<span className="text-on-brand-softer">MEI</span>
            </span>
          </div>
        )}
        <div className={cn('mb-1.5 text-[13px]', isNeg ? 'text-white/80' : 'text-on-brand-soft')}>
          {heroLabel}
        </div>
        <div className="flex items-baseline gap-1">
          <span className="font-mono text-[clamp(2.25rem,1.6rem+2vw,2.875rem)] font-semibold leading-[0.95] tracking-[-0.03em] text-white tabular-nums">
            {heroValue}
          </span>
          {heroSuffix && (
            <span className={cn('text-base', isNeg ? 'text-white/70' : 'text-on-brand-softer')}>
              {heroSuffix}
            </span>
          )}
        </div>
      </div>

      {children && <div className="border-t-0 px-[18px] py-4">{children}</div>}

    </div>
  )
}
